<div class="row justify-content-center">
  <div [ngClass]="{'col-12': this.isInPopup, 'col-xl-4 col-lg-5 col-md-6 col-sm-8 mb-5': !this.isInPopup}">
    <h1 class="h3 mb-3 font-weight-normal">Registro de usuario</h1>

    <!-- Paso 1 -->
    <div *ngIf="this.step === 1">
      <div class="form-group">
        <label for="firstName">Nombres</label>
        <input id="firstName" type="text" class="form-control" name="firstName" [(ngModel)]="this.user.UserFirstName">
      </div>
      <div class="form-group">
        <label for="lastName">Apellidos</label>
        <input id="lastName" type="text" class="form-control" name="lastName" [(ngModel)]="this.user.UserLastName">
      </div>
      <div class="form-group">
        <label for="email">Correo electrónico (existente)</label>
        <input id="email" type="email" class="form-control" placeholder="" name="email" [(ngModel)]="this.user.UserEmail">
        <small id="emailHelp" class="form-text text-muted">Se enviará un correo electrónico para activar su cuenta.</small>
      </div>
      <div class="form-group">
        <label for="birthDate">Fecha de nacimiento</label>
        <input id="birthDate" type="date" class="form-control" name="birthDate" placeholder="dd/mm/aaaa" [(ngModel)]="this.user.UserBirthDate">
      </div>
      <div class="form-group">
        <label for="phoneNumber">Número de teléfono</label>
        <input id="phoneNumber" type="text" class="form-control" name="phoneNumber" [(ngModel)]="this.user.UserPhoneNumber">
      </div>
    </div>

    <!-- Paso 2 -->
    <div *ngIf="this.step === 2">
      <div class="form-group" *ngIf="this.user.UserPreferences && this.user.UserPreferences.length > 0">
        <label>Preferencias</label>
        <br>
        <div class="form-check" [ngClass]="{'not-first-line': i > 1}" *ngFor="let preference of this.user.UserPreferences; let i = index;">
          <input class="form-check-input" type="checkbox" id="pref-{{preference.PreferenceId}}" [(ngModel)]="preference.PreferenceIsSelected">
          <label class="form-check-label" for="pref-{{preference.PreferenceId}}">{{preference.PreferenceName}}</label>
        </div>
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1">Equipo favorito</label>
        <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="this.selectedFavouriteTeam">
          <option *ngFor="let team of this.teams" [ngValue]="team">{{team.TeamName}}</option>
        </select>
      </div>
    </div>

    <!-- Paso 3 -->
    <div *ngIf="this.step === 3">
      <div class="form-group">
        <label for="password">Contraseña</label>
        <input id="password" type="password" class="form-control" name="password" [(ngModel)]="this.user.UserPassword">
      </div>
      <div class="form-group">
        <label for="passwordConfirm">Repita contraseña</label>
        <input id="passwordConfirm" type="password" class="form-control" name="passwordConfirm" [(ngModel)]="this.passwordConfirm">
      </div>
    </div>

    <div>
      <button *ngIf="this.step !== 1" class="use-app-colors btn btn-primary  mt-md-3 float-left" type="button" (click)="this.changeStep('DECREASE')">
        <span *ngIf="!this.processing">< Anterior</span>
        <div *ngIf="this.processing" class="spinner-border"></div>
      </button>
      <button class="use-app-colors btn btn-primary mt-md-3 float-right" type="button" (click)="this.changeStep('INCREASE')">
        <span *ngIf="!this.processing && this.step !== 3">Siguiente ></span>
        <span *ngIf="!this.processing && this.step === 3">Registrarse</span>
        <div *ngIf="this.processing" class="spinner-border"></div>
      </button>
      <div class="clearfix"></div>
    </div>

    <div class="mt-1">
      <a (click)="this.goToSignIn()" class="app-link">Ir al inicio de sesión</a>
    </div>

    <div *ngIf="this.error" [innerHTML]="this.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
    <div *ngIf="this.message" [innerHTML]="this.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  </div>
</div>
